module.exports = __webpack_public_path__ + "img/takeBack.e0f9abe4.png";